import { render, staticRenderFns } from "./ConversationStatus.vue?vue&type=template&id=0b781946&"
import script from "./ConversationStatus.vue?vue&type=script&lang=ts&"
export * from "./ConversationStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports